import _ from 'lodash';;
import { observable, action, computed } from 'mobx';

export default class Label {
	store = null;

	constructor (store, data) {
		this.store = store;

		if (_.isEmpty(data)) {

			return;
		}

		this.update(data);
	}

	_id = null;
	get id () {
		return this._id;
	}

	set id (id) {
		this._id = id;
	}

	/**
	 * Observables & Computeds
	 */

 	@observable
 	_name = '';

 	@computed
 	get name () {
 		return this._name;
 	}

 	set name (name) {
 		this._name = name;
 	}

	@observable
	_website = '';

	@computed
	get website () {
		return this._website;
	}

	set website (website) {
		this._website = website;
	}

	@observable
	_genres = '';

	@computed
	get genres () {
		return this._genres;
	}

	set genres (genres) {
		this._genres = genres;
	}

	@observable
	_location = '';

	@computed
	get location () {
		return this._location;
	}

	set location (location) {
		this._location = location;
	}

	@observable
	_active = true;

	@computed
	get active () {
		return this._active;
	}

	set active (active) {
		this._active = active;
	}

	@computed
	get serialized () {
		return {
			_id: this._id,
			website: this._website,
			name: this._name,
			genres: this._genres,
			location: this._location,
			active: this._active
		};
	}

	/**
	 * Actions
	 */

	@action.bound
	async save (opts) {
		await this.store.saveLabel(this, opts);
	}

	@action.bound
	async delete () {
		this.store.deleteLabel(this);
	}

	@action
	update ({ _id, website, name, genres, location, active }) {
		this.id = _.defaultTo(_id, this.id);
		this.website = _.defaultTo(website, this.website);
		this.name = _.defaultTo(name, this.name);
		this.genres = _.defaultTo(genres, this.genres);
		this.location = _.defaultTo(location, this.location);
		this.active = _.defaultTo(active, this.active);
	}
}
